export const isValidRut = (rut) => {
  if (!rut || typeof rut !== 'string') return false;
  
  const cleanRut = rut.replace(/[^0-9kK]/g, '').toUpperCase();
    if (cleanRut.length < 8) return false;
  
  const body = cleanRut.slice(0, -1);
  const dv = cleanRut.slice(-1);
  
  if (!/^\d+$/.test(body)) return false;
  
  let sum = 0;
  let multiplier = 2;
  
  for (let i = body.length - 1; i >= 0; i--) {
    sum += parseInt(body[i], 10) * multiplier;
    multiplier = multiplier === 7 ? 2 : multiplier + 1;
  }
  
  const remainder = sum % 11;
  let computedDv;
  
  if (remainder === 0) computedDv = '0';
  else if (remainder === 1) computedDv = 'K';
  else computedDv = (11 - remainder).toString();
  
  return computedDv === dv;
};